import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';

import { destinationsApi } from '../../api/lib/destinations';
import { destinationsKeys } from '../../api/query-keys/destinations';
import { Destination } from '../../api/types/destination';

import { PaginatedResponse } from '@/types/responses/paginated-response';

export const useDestinations = ({
  page,
  perPage,
  search,
  enabled,
}: {
  page: number;
  perPage: number;
  search?: string;
  enabled?: boolean;
}) => {
  return useQuery<PaginatedResponse<Destination>, ApiError>({
    queryKey: destinationsKeys.list(page, perPage, search),
    queryFn: () => destinationsApi.fetchDestinations(page, perPage, search),
    enabled,
  });
};
